import { Component } from '@angular/core'
import { Notification } from '../../models/notification'

/**
 * component subscribes to the notification queue and displays any occuring notification as toast
 */

@Component({
  selector: 'jml-lib-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent {
  // true when the user clicks the (i)nfo-Button on an error message
  public display = false
  public displayedNotification: Notification

  constructor() {}

  public showDetails(notification: Notification) {
    this.displayedNotification = notification
    this.display = true
  }
}
